import React, { Component } from 'react';
import { navigateTo } from "gatsby-link";
import { withFormik } from 'formik';
import {
  FormField,
  FormFieldInput,
  FormFieldLabel,
  FormFieldError,
  FormFieldInline,
  FormFieldButton,
  FormFieldHelp
} from 'react-foundation-components/lib/global/forms';
import { Row, Column } from 'react-foundation-components/lib/global/grid';
import { Callout } from 'react-foundation-components/lib/global/callout';
import Yup from 'yup';

const encode = (data) => {
  return Object.keys(data)
  .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
  .join("&");
}

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  // handleSubmit = e => {
  //   const { submitted } = this.state

  //   fetch("/", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     body: encode({ "form-name": "contact", ...this.state })
  //   })
  //   .then(() => this.setState({ submitted: !submitted }))
  //   .catch(error => alert(error))

  //   e.preventDefault();
  // };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { name, email, message } = this.state;
    const {
      values,
      touched,
      errors,
      dirty,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      handleReset,
      setStatus,
      status
    } = this.props;

    if (status && status.success) {
      return (
        <Row>
          <Column className="small-12">
            <Callout className="text-center" color="success">
              <p>Thank you, your message was sent sucessfully.</p>
              <p>We'll answer you ASAP</p>
            </Callout>
            <button
              className="button expanded success"
              onClick={() => {
                handleReset()
              }
            }>
              Click here to send another message
            </button>
          </Column>
        </Row>
      )
    }

    return (

      <form
        name="contact"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        noValidate
        onSubmit={handleSubmit}
      >
        <Row>
          <Column className="small-12">
            <fieldset className="dashed-section">
              <h6>Your contact details</h6>
              <Row>
                <Column className="small-12 medium-6">
                  <p hidden>
                    <label>
                    Don’t fill this out: <input name="bot-field" onChange={handleChange} />
                    </label>
                  </p>
                  <FormField error={errors.name && touched.name}>
                    <FormFieldLabel>Your name</FormFieldLabel>
                    <FormFieldInput name="name" placeholder="Jo Bloggs" onChange={handleChange} onBlur={handleBlur} required />
                    {errors.name && touched.name && <FormFieldError>{errors.name}</FormFieldError>}
                  </FormField>
                </Column>
                <Column className="small-12 medium-6">
                  <FormField error={errors.email && touched.email}>
                    <FormFieldLabel>Your email</FormFieldLabel>
                    <FormFieldInput name="email" placeholder="jobloggs@email.com" onChange={handleChange} onBlur={handleBlur} required />
                    {errors.email && touched.email && <FormFieldError>{errors.email}</FormFieldError>}
                  </FormField>
                </Column>
              </Row>
            </fieldset>
          </Column>
          <Column className="small-12">
            <h6>Your Message</h6>
            <FormField error={errors.message && touched.message}>
              <FormFieldLabel>Message</FormFieldLabel>
              <FormFieldInput name="message" placeholder="Your message here" type="textarea" onChange={handleChange} onBlur={handleBlur} required />
              {errors.message && touched.message && <FormFieldError>{errors.message}</FormFieldError>}
            </FormField>
          </Column>
          <Column className="small-12">
            <button disabled={isSubmitting} className="button expanded success float-right" type="submit">
              {
                isSubmitting ?
                'Sending your message...' :
                status && status.success ?
                  'Message Sent' : `Send message`
              }
            </button>
          </Column>
        </Row>
      </form>
    );
  }
}

const ContactFormWithFormik = withFormik({
  mapPropsToValues: () => ({ name: '', email: '', message: '' }),
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .required('Name is required'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    message: Yup.string()
      .required('Message is required')
  }),
  handleReset: ({ setStatus }) => {
    setStatus({ success: false })
  },
  handleSubmit: (values, { props, setSubmitting, setErrors, setStatus, resetForm }) => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...values })
    })
    .then(() => {
      setStatus({ success: true });
      setSubmitting(false)
    }).catch((error) => {
      console.log('there was an error sending your message', error);
      setSubmitting(false)
      setStatus({ success: false })
    })
  },
  displayName: 'ContactForm', // helps with React DevTools
})(ContactForm);

export default ContactFormWithFormik;


// WEBPACK FOOTER //
// ./src/components/ContactForm.js